import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import '../SelectedHistory.scss';
import { convertAmount, tableBetHistoryStore, useTranslation } from '@pascal/pascal-core';
import { CARDS_TYPE, COMBINATIONS_PAYOUTS, HISTORY_CARDS } from '../../../enums/cardTypes';

export const SelectedRow = observer(() => {
  const { thirdStep } = tableBetHistoryStore;
  const { data: thirdStepData } = thirdStep;
  const t = useTranslation();
  const winCombination = useMemo(() => {
    return COMBINATIONS_PAYOUTS.find(
      ({ winType }) => winType === thirdStepData?.roundData?.winCombination
    );
  }, [thirdStepData]);

  return (
    <div className='tb-game-history-wrp'>
      <div className='tb-game-history-top-cards-wrp'>
        <div className='tb-game-history-top-cards-inner'>
          {thirdStepData?.roundData &&
            thirdStepData.roundData.cards.map(({ card, isWin }) => (
              <div key={card} className={`tb-game-history-cards-item-wrp ${isWin ? 'win' : ''} `}>
                <div className={`tb-game-history-cards-item-inner ${CARDS_TYPE[card]}`}>
                  <img src={HISTORY_CARDS[CARDS_TYPE[card]]} alt='' />
                </div>
              </div>
            ))}
        </div>
      </div>
      <p className='tb-game-history-cards-title'>{t(winCombination?.type)}</p>
      {/* <div className='tb-game-history-bot-cards-wrp'> */}
      {/*  <div className='tb-game-history-bot-cards-img'> */}
      {/*    <img src={winCombination?.img} alt='' /> */}
      {/*  </div> */}
      {/* </div> */}
      <div className='tb-game-history-bet-info-wrp'>
        <div className='tb-game-history-bet-info-header'>
          <div className='tb-game-history-bet-info-h-cl'>
            <p className='tb-history-cl-header-txt'>{t('BET_AMOUNT')}</p>
          </div>
          <div className='tb-game-history-bet-info-h-cl'>
            <p className='tb-history-cl-header-txt'>{t('ODD')}</p>
          </div>
          <div className='tb-game-history-bet-info-h-cl'>
            <p className='tb-history-cl-header-txt'>{t('WIN')}</p>
          </div>
        </div>
        <div className='tb-game-history-bet-info-main'>
          <div className='tb-game-history-bet-info-main-row'>
            <div className='tb-his-bet-info-main-row-ins'>
              <div className='tb-his-bet-info-main-row-ins-cl'>
                <p className='tb-his-bet-info-main-txt'>
                  {convertAmount(thirdStepData.amount)}{' '}
                  {thirdStepData?.freeBetId ? `(${t('FREE_BET')})` : ''}
                </p>
              </div>
              <div className='tb-his-bet-info-main-row-ins-cl'>
                <p className='tb-his-bet-info-main-txt'>{thirdStepData.odd}</p>
              </div>
              <div className='tb-his-bet-info-main-row-ins-cl'>
                <p className='tb-his-bet-info-main-txt win'>
                  {convertAmount(thirdStepData.winAmount)}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});
